import mixitup from 'mixitup';
import mixitupMultifilter from '../../../General/Mixitup/multifilter.js';

mixitup.use(mixitupMultifilter);

const mixitupContainer = document.querySelector('.packages-overview ');

if (mixitupContainer) {
    var mixer = mixitup(mixitupContainer, {
        load: {
            filter: 'all',
        },
        selectors: {
            target: '.package-teaser',
        },
        animation: {
            easing: 'ease-in-out',
        },
        multifilter: {
            enable: true,
        },
        controls: {
            toggleLogic: 'and',
        },
    });
}

//Mobile Filter:

const filterMobileButton = document.querySelector('.filter-mobile-button');
const packagesFilterMobile = document.querySelector('.packages-filter-mobile');
const packagesFilterMobileTitle = document.querySelector('.packages-filter-mobile__title .icon--menu-close');
const filterButtonApply = document.querySelector('.filter-button-apply');
const body = document.querySelector('body');

if (filterMobileButton && packagesFilterMobile && packagesFilterMobileTitle && filterButtonApply) {
    filterMobileButton.addEventListener('click', function () {
        packagesFilterMobile.classList.add('open');
        body.classList.add('js-filter-packages-open');
    });

    function closePackagesFilterMobile() {
        packagesFilterMobile.classList.remove('open');
        body.classList.remove('js-filter-packages-open');
    }

    packagesFilterMobileTitle.addEventListener('click', closePackagesFilterMobile);
    filterButtonApply.addEventListener('click', closePackagesFilterMobile);
}
